document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector(".js-header-nav-list")
  const menu = document.querySelector(".js-header-nav-menu")

  if (!trigger || !menu) return

  function showMenu() {
    menu.classList.add("is-shown")
  }

  function hideMenuIfNotHovered() {
    setTimeout(() => {
      menu.classList.remove("is-shown")
    }, 10)
  }

  trigger.addEventListener("mouseenter", showMenu)
  trigger.addEventListener("mouseleave", hideMenuIfNotHovered)
})
